// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.document-panel-compare{flex-grow:1}`, "",{"version":3,"sources":["webpack://./src/routes/file_view_comparison/documents_panel/doc_view/index.scss"],"names":[],"mappings":"AAAA,wBACE,WAAA","sourcesContent":[".document-panel-compare {\n  flex-grow: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
